import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";

export const IconEraserSimple: React.FC<CentralIconBaseProps> = (props) => {
  return <CentralIconBase {...props} ariaLabel="eraser-simple, rubber, clean-up"><path d="M13.0124 2.92687C13.6958 2.24345 14.8039 2.24345 15.4873 2.92687L21.0731 8.51266C21.7565 9.19607 21.7565 10.3041 21.0731 10.9875L14.5606 17.5L6.49997 9.43931L13.0124 2.92687Z" fill="currentColor"/><path d="M5.43931 10.5L2.92663 13.0127C2.24321 13.6961 2.24321 14.8041 2.92663 15.4875L8.51241 21.0733C9.19583 21.7567 10.3039 21.7567 10.9873 21.0733L13.5 18.5606L5.43931 10.5Z" fill="currentColor"/></CentralIconBase>;
};

export default IconEraserSimple;
